<div class="modal-header">
  <h4 class="modal-title header-5">
    {{ configs.title || "Test Case TC_US2_POS_04" }}
  </h4>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
      alt="Close"
    />
  </button>
</div>

<div class="modal-body">
  <div class="accordion-container">
    <div
      class="accordion-section"
      *ngFor="let section of sections; let i = index"
    >
      <div
        class="accordion-header"
        (click)="toggleSection(i)"
        (keydown.enter)="toggleSection(i)"
      >
        <span class="section-title">{{ section.title }}</span>
        <button
          class="toggle-button"
          title="Toggle"
        >
          <img
            *ngIf="isExpanded(i)"
            src="assets/images/virtusa-icons/remove-outline.svg"
            alt="remove"
          />
          <img
            *ngIf="!isExpanded(i)"
            src="assets/images/virtusa-icons/add-outline.svg"
            alt="add"
          />
        </button>
      </div>
      <div class="accordion-content" *ngIf="isExpanded(i)">
        <div class="field-item" *ngFor="let field of section.fields">
          <div class="field-label">{{ field.label }}</div>
          <div class="field-value">
            <ng-container
              *ngIf="field.label === 'Code Snippets'; else otherFields"
            >
              <app-code-snippet [code]="field.value"></app-code-snippet>
            </ng-container>
            <ng-template #otherFields>
              <ng-container
                *ngIf="field.label === 'Acceptance Criteria'; else normalField"
              >
                <ul class="criteria-list" *ngIf="!hasNumbering(field.value)">
                  <li
                    *ngFor="let item of getAcceptanceCriteriaList(field.value)"
                  >
                    {{ item }}
                  </li>
                </ul>
                <ol class="criteria-list numbered-list" *ngIf="hasNumbering(field.value)">
                  <li
                    *ngFor="let item of getCleanListItems(field.value)"
                  >
                    {{ item }}
                  </li>
                </ol>
              </ng-container>
              <ng-template #normalField>
                <ng-container
                  *ngIf="
                    field.label === 'Prerequisites' ||
                      field.label === 'Test Steps';
                    else simpleText
                  "
                >
                  <ul class="criteria-list" *ngIf="!hasNumbering(field.value)">
                    <li *ngFor="let item of getListItems(field.value)">
                      {{ item }}
                    </li>
                  </ul>
                  <ol class="criteria-list numbered-list" *ngIf="hasNumbering(field.value)">
                    <li *ngFor="let item of getCleanListItems(field.value)">
                      {{ item }}
                    </li>
                  </ol>
                </ng-container>
                <ng-template #simpleText>
                  {{ field.value }}
                </ng-template>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button class="btn-accello-primary-light" (click)="close()">Close</button>
  </div>
</div>
